// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__8gy6Y","inner":"Footer_inner__3VkW5","nextIcon":"Footer_nextIcon__3ZQEz","innerLeft":"Footer_innerLeft__287SC"};